import { render } from "./PreviewLink.vue?vue&type=template&id=6a884076"
import script from "./PreviewLink.vue?vue&type=script&lang=js"
export * from "./PreviewLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__